import { Link } from 'react-router-dom'
import { Menu } from 'antd'
import { menuConfig } from '../../core/configs/menu'

const { SubMenu } = Menu

export const LayoutMenu = () => {
  return (
    <Menu
      theme="light"
      mode="inline"
      style={{ marginTop: '50px' }}
      defaultSelectedKeys={['0']}
    >
      {menuConfig.map(({ title, icon, submenu }) => (
        <SubMenu key={title} icon={icon} title={title}>
          {submenu.map(({ title, route }) => (
            <Menu.Item key={title}>
              <Link to={route}>{title}</Link>
            </Menu.Item>
          ))}
        </SubMenu>
      ))}
    </Menu>
  )
}
